var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promises.length)?_c('div',{staticClass:"mb-3"},[_c('b-progress',{attrs:{"max":_vm.total,"value":_vm.completed,"show-progress":"","animated":"","variant":"warning"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }